"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _shortId = _interopRequireDefault(require("../utils/shortId"));

var _SideNavList = _interopRequireDefault(require("./_SideNavList"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _icon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/icon.css") : void 0);

var _sideNav = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/side-nav.css") : void 0);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context3; (0, _forEach.default)(_context3 = ownKeys(Object(source), true)).call(_context3, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context4; (0, _forEach.default)(_context4 = ownKeys(Object(source))).call(_context4, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread({}, _icon.default), _sideNav.default));
var isUsingCssModules = _sideNav.default && (0, _keys.default)(_sideNav.default).length > 0;

var SideNavListItem = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(SideNavListItem, _React$Component);

  var _super = _createSuper(SideNavListItem);

  function SideNavListItem(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SideNavListItem);
    _this = _super.call(this, props);

    _this.handleExpand = function () {
      _this.setState({
        expanded: !_this.state.expanded
      });
    };

    _this.state = {
      expanded: _this.props.expanded ? _this.props.expanded : false
    };
    return _this;
  }

  (0, _createClass2.default)(SideNavListItem, [{
    key: "getDerrivedStateFromProps",
    value: function getDerrivedStateFromProps(updatedProps, previousState) {
      if (updatedProps.expanded !== previousState.expanded) {
        return {
          expanded: updatedProps.expanded
        };
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this,
          _context,
          _context2;

      var _this$props = this.props,
          children = _this$props.children,
          condensed = _this$props.condensed,
          glyph = _this$props.glyph,
          id = _this$props.id,
          isSubItem = _this$props.isSubItem,
          name = _this$props.name,
          _onClick = _this$props.onClick,
          onItemSelect = _this$props.onItemSelect,
          selected = _this$props.selected,
          selectedId = _this$props.selectedId,
          url = _this$props.url,
          expandSubmenuLabel = _this$props.expandSubmenuLabel,
          cssNamespace = _this$props.cssNamespace,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["children", "condensed", "glyph", "id", "isSubItem", "name", "onClick", "onItemSelect", "selected", "selectedId", "url", "expandSubmenuLabel", "cssNamespace"]);

      var nestedListId = _shortId.default.generate();

      var getClasses = function getClasses() {
        return classnames("".concat(cssNamespace, "-nested-list__link"), {
          'is-selected': selected,
          'is-expanded': _this2.state.expanded
        });
      };

      var hasChild = (0, _some.default)(_context = _react.default.Children.toArray(children)).call(_context, function (child) {
        return child.type === _SideNavList.default;
      });

      var renderLink = function renderLink() {
        var link = /*#__PURE__*/_react.default.createElement("a", {
          className: getClasses(),
          href: url,
          onClick: !hasChild ? function (e) {
            !hasChild && _onClick(e);
            onItemSelect(e, id, hasChild);
          } : null
        }, glyph ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
          ariaHidden: true,
          className: classnames("".concat(cssNamespace, "-nested-list__icon")),
          glyph: glyph
        }) : null, /*#__PURE__*/_react.default.createElement("span", {
          className: classnames("".concat(cssNamespace, "-nested-list__title"))
        }, name));

        if (hasChild) {
          var divClasses = classnames("".concat(cssNamespace, "-nested-list__content"), 'has-child', {
            'is-selected': selected
          });
          return /*#__PURE__*/_react.default.createElement("div", {
            className: divClasses,
            onClick: function onClick(e) {
              /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
              _onClick(e);

              onItemSelect(e, id, hasChild);
            }
          }, link, /*#__PURE__*/_react.default.createElement(_Button.default, {
            "aria-controls": nestedListId,
            "aria-expanded": _this2.state.expanded,
            "aria-haspopup": "true",
            "aria-label": expandSubmenuLabel,
            className: classnames("".concat(cssNamespace, "-nested-list__button"), (0, _defineProperty3.default)({}, "".concat(cssNamespace, "-button"), isUsingCssModules)),
            onClick: function onClick() {
              _this2.handleExpand();
            }
          }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
            ariaHidden: true,
            glyph: _this2.state.expanded ? 'navigation-down-arrow' : 'navigation-right-arrow'
          })));
        } else {
          return link;
        }
      };

      return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({}, props, {
        className: classnames("".concat(cssNamespace, "-nested-list__item")),
        key: id
      }), url && renderLink(), (0, _map.default)(_context2 = _react.default.Children.toArray(children)).call(_context2, function (child) {
        if (child.type !== _SideNavList.default) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            children: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, glyph ? /*#__PURE__*/_react.default.createElement("span", {
              "aria-hidden": true,
              className: classnames("".concat(cssNamespace, "-nested-list__icon"), "sap-icon--".concat(glyph))
            }) : null, /*#__PURE__*/_react.default.createElement("span", {
              className: classnames("".concat(cssNamespace, "-nested-list__title"))
            }, child.props.children)),
            className: getClasses(),
            onClick: function onClick(e) {
              _onClick(e);

              onItemSelect(e, id, hasChild);

              if (hasChild) {
                _this2.handleExpand();
              }
            }
          });
        } else if (child.type === _SideNavList.default) {
          return /*#__PURE__*/_react.default.cloneElement(child, {
            hasParent: true,
            id: nestedListId,
            onItemSelect: onItemSelect,
            open: _this2.state.expanded,
            selectedId: selectedId
          });
        } else {
          return child;
        }
      }));
    }
  }]);
  return SideNavListItem;
}(_react.default.Component);

process.env.NODE_ENV !== "production" ? SideNavListItem.propTypes = {
  /** Node(s) to render within the component */
  children: _propTypes.default.node,

  /** Internal use only */
  condensed: _propTypes.default.bool,

  /** Set to **true** to have this item initially render as expanded and its children items shown */
  expanded: _propTypes.default.bool,

  /** Localized text for the screen reader label for the button that expands submenus. */
  expandSubmenuLabel: _propTypes.default.string,

  /** The icon to include. See the icon page for the list of icons */
  glyph: _propTypes.default.string,

  /** Value for the `id` attribute on the element */
  id: _propTypes.default.string,

  /** Internal use only */
  isSubItem: _propTypes.default.bool,

  /** Localized text for the item (when `url` is provided) */
  name: _propTypes.default.string,

  /** Internal use only */
  selected: _propTypes.default.bool,

  /** Internal use only */
  selectedId: _propTypes.default.string,

  /** Enables use of `<a>` element. Value to be applied to the anchor\'s `href` attribute */
  url: _propTypes.default.string,

  /**
   * Callback function; triggered when SideNavListItem is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
  */
  onClick: _propTypes.default.func,

  /** Internal use only */
  onItemSelect: _propTypes.default.func
} : void 0;
SideNavListItem.defaultProps = {
  condensed: false,
  onClick: function onClick() {}
};
SideNavListItem.displayName = 'SideNav.ListItem';

var _default = (0, _withStyles.default)(SideNavListItem);

exports.default = _default;